import LeadsTable from './LeadsTable';
import { useUser } from '../../Use-auth';
import RoleBasedLayout from '../RoleBasedLayout';
import { useState } from 'react';
import { FileText, ArrowUpAZ, UserStar } from "lucide-react";

export default function Contacts() {
    const { data: user } = useUser();
    const isAdminOrManager = user.department === "Admin" || user.department === "Management";
    const [activeTab, setActiveTab] = useState("wonleads");

    return (
        <div>
            {isAdminOrManager ? (
                <RoleBasedLayout>
                    <div className='tabs-header flex border-b border-gray-300 mb-4 fixed w-full bg-white z-20'>
                        <div className='tabs-header flex border-b text-sm border-gray-300 mb-4 fixed w-full bg-white z-20'>
                            <button
                                onClick={() => setActiveTab("wonleads")}
                                className={`px-4 py-2 rounded-t-lg font-medium
      transition-all duration-200
      flex items-center gap-2
      text-[12px] lg:text-sm
       ${activeTab === "wonleads"
                                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                        : "border-transparent text-gray-500 hover:text-blue-500"
                                    }`}
                            >
                                <div className="flex gap-1 items-center">
                                    <UserStar size={18} className='hidden zs:block'/>
                                    Won Leads
                                </div>
                            </button>
                            <button
                                onClick={() => setActiveTab("normalleads")}
                                className={`px-4 py-2 rounded-t-lg font-medium
      transition-all duration-200
      flex items-center gap-2
      text-[12px] lg:text-sm ${activeTab === "normalleads"
                                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                        : "border-transparent text-gray-500 hover:text-blue-500"
                                    }`}
                            >
                                <div className="flex gap-1 items-center">
                                    <ArrowUpAZ size={18} className='hidden zs:block' />
                                    Leads
                                </div>
                            </button>

                            <button
                                onClick={() => setActiveTab("leads")}
                                className={`px-4 py-2 rounded-t-lg font-medium
      transition-all duration-200
      flex items-center gap-2
      text-[12px] lg:text-sm ${activeTab === "leads"
                                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600 "
                                        : "border-transparent text-gray-500 hover:text-blue-500"
                                    }`}
                            >
                                <div className="flex gap-1 items-center">
                                    <FileText size={18} className='hidden zs:block'/>
                                    Contacts
                                </div>
                            </button>
                        </div>

                    </div>
                    <div className='pt-[40px]'>
                        {activeTab === 'leads' && (
                            <LeadsTable leadsType="leads" setActiveTab={setActiveTab} />
                        )}
                        {activeTab === 'normalleads' && (
                            <LeadsTable leadsType="normalleads" setActiveTab={setActiveTab} />
                        )}
                        {activeTab === 'wonleads' && (
                            <LeadsTable leadsType="wonleads" setActiveTab={setActiveTab} />
                        )}
                    </div>
                </RoleBasedLayout>
            ) : (

                <RoleBasedLayout>
                    <LeadsTable
                        leadsType="leads"
                        setActiveTab={isAdminOrManager ? setActiveTab : undefined}
                    />
                </RoleBasedLayout>
            )}

        </div>
    )
}
